import { render, staticRenderFns } from "./IncomeRecord.vue?vue&type=template&id=3a0bbd5e&scoped=true&"
import script from "./IncomeRecord.vue?vue&type=script&lang=js&"
export * from "./IncomeRecord.vue?vue&type=script&lang=js&"
import style0 from "./IncomeRecord.vue?vue&type=style&index=0&id=3a0bbd5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0bbd5e",
  null
  
)

export default component.exports